export const selectBackButtonRoute = state => state.ui.previousRoutes[0]
export const selectShouldClearRouteOnUserMenuBackButtonClick = state => state.ui.clearRouteOnUserMenuBackButtonClick
export const selectModalQueue = state => state.ui.modalQueue
export const selectFirstModalInQueue = state => state.ui.modalQueue[0]
